export default __webpack_public_path__ + "static/media/SizesImg.b58b21dd.jpg";